{
  "interface": "Interface",
  "newInterface": "Nouvelle interface",
  "updateInterface": "Modifier l’interface",
  "generateNewInterface": "Générer une nouvelle interface",
  "tabs": {
    "mobileApp": {
      "title": "Applications mobiles",
      "column": {
        "organizationName": "Nom de l’organisation",
        "name": "Nom de l’interface",
        "deviceTypes": "Type d’équipement",
        "updatedAt": "Date de mise à jour"
      },
      "form": {
        "information": {
          "title": "Informations",
          "organizationName": "Nom de l’organisation",
          "name": "Nom",
          "description": "Description"
        },
        "deviceTypes": {
          "title": "Propriétés des gammes d'équipements",
          "label": "Types",
          "add": "Ajouter",
          "save": "Sauvegarder",
          "cancel": "Annuler",
          "noLabel": "Type inconnu"
        },
        "validation": {
          "name": "Le nom de l’interface est obligatoire",
          "nameFormat": "Le nom de l’interface ne peut contenir que des caractères alphanumériques ou des underscores",
          "uniqueName": "Le nom de l’interface doit être unique"
        }
      },
      "empty": "Aucune application mobile disponible"
    },
    "thirdPartyApp": {
      "title": "Applications tierces",
      "column": {
        "organizationName": "Nom de l’organisation",
        "interfaceName": "Nom de l’interface",
        "authMethod": "Méthode d’authentification",
        "profile": "Profil",
        "updatedAt": "Date de mise à jour",
        "status": "Statut"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "authMethod": {
        "clientGrant": "Client Grant",
        "mtls": "mTLS",
        "userCredentials": "Identification client"
      },
      "form": {
        "title": "Informations",
        "organizationName": "Nom de l’organisation",
        "name": "Nom de l’interface",
        "profile": {
          "label": "Profil",
          "placeholder": "Sélectionnez un profil"
        },
        "sectors": {
          "label": "Secteurs",
          "placeholder": "Selectionnez des secteurs"
        },
        "authenticationType": {
          "label": "Type d’authentification",
          "clientGrant": "ClientGrant",
          "mtls": "mTLS",
          "userCredentials": "Nom d’utilisateur/Mot de passe"
        },
        "validation": {
          "organizationName": "Le nom de l’organisation est obligatoire",
          "name": "Le nom est obligatoire",
          "profile": "Le profil est obligatoire",
          "sectors": "La sélection d’un ou plusieurs secteurs est obligatoire",
          "authenticationType": "Le type d’authentification est obligatoire",
          "nameFormat": "Le nom de l’interface ne peut contenir que des caractères alphanumériques ou des underscores",
          "uniqueName": "Le nom de l’interface doit être unique",
          "config": {
            "url": "L’URL est obligatoire",
            "port": "Le port est obligatoire",
            "clientId": "Le client Id est obligatoire",
            "authenticationType": "Le type d’authentification est obligatoire",
            "username": "Le nom d'utilisateur est obligatoire",
            "password": "Le mot de passe est obligatoire",
            "primaryHost": "L’ID de l'hôte primaire est obligatoire",
            "edgeNodeGroup": "L’ID de groupe est obligatoire",
            "edgeNode": "L’ID du nœud edge est obligatoire",
            "type": "Le type est obligatoire",
            "urlFormat": "L’URL doit être une IP ou un DNS valide"
          },
          "protocol": "Le protocole est obligatoire"
        },
        "update": {
          "sidePanelTitle": "Modification de l’interface tierce",
          "information": {
            "title": "Important",
            "content": "Si vous avez perdu votre client secret, veuillez supprimer cette interface, et en créer une nouvelle"
          }
        },
        "confirmCancelUpdate": {
          "title": "Annuler la modification de l’interface",
          "message": "Êtes-vous sûr de vouloir annuler la modification de l’interface ?"
        },
        "confirmCancelCreate": {
          "title": "Annuler la création de l’interface",
          "message": "Êtes-vous sûr de vouloir annuler la création de l’interface ?"
        },
        "protocol": {
          "label": "Protocole",
          "help": "L’autorité de certification est requise dans le magasin des éditeurs de confiance pour se connecter au broker."
        },
        "url": "URL",
        "port": "Port",
        "clientId": "Client Id",
        "username": "Nom d’utilisateur",
        "password": "Mot de passe",
        "primaryHost": "ID de l’hôte primaire",
        "edgeNodeGroup": "ID de groupe",
        "edgeNode": "ID du nœud edge"
      },
      "creationModalSuccess": {
        "header": {
          "title": "Succès",
          "info": "Avertissement : Conservez bien ces informations, elles ne seront plus consultables une fois cette page fermée."
        },
        "clientId": {
          "label": "ClientId"
        },
        "secret": {
          "label": "Secret"
        },
        "copyToClipboard": {
          "copied": "Copié",
          "buttonTitle": "copier dans le presse-papiers"
        }
      },
      "empty": "Aucune application tierce n’est disponible",
      "licenseMessage": {
        "disableNewInterface": "La limite de votre licence est atteinte, la création d’interface est désactivée.",
        "disableActivateInterface": "La limite de votre licence est atteinte, l’activation d’interface est désactivée."
      }
    }
  },
  "action": {
    "delete": {
      "confirm": {
        "title": "Supprimer l’interface",
        "message": "L’interface {name} va être supprimée."
      }
    },
    "deactivate": {
      "confirm": {
        "title": "Désactiver l’interface",
        "message": "L’interface {name} va être désactivée."
      }
    },
    "activate": {
      "confirm": {
        "title": "Activer l’interface",
        "message": "L’interface {name} va être activée."
      }
    }
  }
}
